import { useState } from "react";
import { IContestState } from "@/types";
import { ContestAll, ContestInfo } from "@/types/CompetitionTypes";

const initialState = {
  allContests: [],
  contests: [],
  history: [],
  isLoading: true,
};

export const initialPageState = {
  selectedPosition: undefined,
  lineup: [],
  contest: null,
  isLoading: false,
  contestInfo: null,
  currentTeam: null,
  team: [],
  seasonGames: [],
  isEdit: false,
  playerScores: [],
  myEntry: null
}

export type LineupType = {
  label: string
  position: string
  index: number
  player: null | any
}

export type PageStateType = {
  selectedPosition: null | number
  lineup: LineupType[]
  contest: ContestAll | null
  isLoading: boolean
  contestInfo: ContestInfo | null
  currentTeam: any
  team: any[]
  seasonGames: any[]
  isEdit: boolean
  playerScores: any[]
  myEntry: any
}

const ContestState = () => {
  const [data, setData] = useState<IContestState>(initialState);
  const [pageState, setPageState] = useState<PageStateType>(initialPageState)

  const actions = {
    setContests: (data: IContestState) => setData(data),
    setSelectedPosition: (position: number) => setPageState((prev) => ({
      ...prev,
      selectedPosition: position
    })),
    setLineup: (lineup: LineupType[]) => setPageState((prev) => ({
      ...prev,
      lineup
    })),
    setContest: (contest: ContestAll | null) => setPageState((prev) => ({
      ...prev,
      contest
    })),
    setIsLoading: (isLoading: boolean) => setPageState((prev) => ({
      ...prev,
      isLoading
    })),
    setContestInfo: (contestInfo: ContestInfo) => setPageState((prev) => ({
      ...prev,
      contestInfo
    })),
    setCurrentTeam: (currentTeam: any) => setPageState((prev) => ({
      ...prev,
      currentTeam
    })),
    setTeam: (team: any) => setPageState((prev) => ({
      ...prev,
      team
    })),
    setSeasonGames: (seasonGames: any[]) => setPageState((prev) => ({
      ...prev,
      seasonGames
    })),
    setIsEdit: (isEdit: boolean) => setPageState((prev) => ({
      ...prev,
      isEdit
    })),
    setPlayerScores: (playerScores: any[]) => setPageState((prev) => ({
      ...prev,
      playerScores
    })),
    setContestEntry: (myEntry: any) => setPageState((prev) => ({
      ...prev,
      myEntry
    })),
    resetContestPageState: () => setPageState(initialPageState)
  };

  return {
    data: {
      ...data,
      pageState,
    },
    actions,
  };
};

export default ContestState;
